import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Component, OnInit, Inject, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { ESSENTIALS, MATERIAL_BUTTONS, MATERIAL_LAYOUT } from '../../utils/shared-components';

@Component({
  selector: "app-sim-nao-modal",
  templateUrl: "./sim-nao-modal.component.html",
  styleUrls: ["./sim-nao-modal.component.css"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ESSENTIALS, MATERIAL_BUTTONS, MATERIAL_LAYOUT],
})
export class SimNaoModalComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<SimNaoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {}

  ngOnInit() {}
}

export interface ConfirmDialogData {
  title: string;
  msg: string;
}
